import { useState, useEffect, useRef } from "react";

/* ✅ Static slides (optimized) */
const slides = [
  {
    id: "slide-1",
    image: "https://images.unsplash.com/photo-1500382017468-9049fed747ef",
    title: "Premium Agro Commodities",
    text: "Exporting Trust Worldwide",
  },
  {
    id: "slide-2",
    image: "/images/slide1.png",
    title: "Global Export Quality",
    text: "From Farms to Markets",
  },
];

export default function Hero() {
  const [current, setCurrent] = useState(0);
  const intervalRef = useRef(null);

  /* ✅ Auto Slide */
  useEffect(() => {
    startAutoSlide();
    return stopAutoSlide;
  }, []);

  const startAutoSlide = () => {
    intervalRef.current = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 4000);
  };

  const stopAutoSlide = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
  };

  /* ✅ Keyboard navigation */
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "ArrowLeft") prevSlide();
      if (e.key === "ArrowRight") nextSlide();
    };

    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, []);

  const prevSlide = () => {
    setCurrent((prev) =>
      prev === 0 ? slides.length - 1 : prev - 1
    );
  };

  const nextSlide = () => {
    setCurrent((prev) => (prev + 1) % slides.length);
  };

  return (
    <section
      id="hero"
      className="relative h-screen overflow-hidden reveal"
      onMouseEnter={stopAutoSlide}
      onMouseLeave={startAutoSlide}
    >
      {/* SLIDES */}
      {slides.map((slide, index) => (
        <div
          key={slide.id}
          className={`absolute w-full h-full transition-all duration-1000 ${
            index === current
              ? "opacity-100 scale-100 z-10"
              : "opacity-0 scale-105"
          }`}
        >
          {/* IMAGE */}
          <img
            src={slide.image}
            alt={slide.title}
            className="w-full h-full object-cover"
          />

          {/* OVERLAY (Gradient for readability) */}
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/40 to-black/70 flex items-center justify-center text-white text-center">
            <div className="p-10 max-w-2xl">
              
              <h1 className="text-4xl md:text-6xl font-bold mb-4 leading-tight">
                {slide.title}
              </h1>

              <p className="mb-6 text-lg opacity-90">
                {slide.text}
              </p>

              {/* CTA BUTTON */}
              <a
                href="#contact"
                className="inline-block bg-green-600 px-6 py-3 rounded text-white font-medium hover:bg-green-700 transition"
              >
                Get Quote
              </a>

            </div>
          </div>
        </div>
      ))}

      {/* LEFT ARROW */}
      <button
        onClick={prevSlide}
        aria-label="Previous Slide"
        className="absolute left-5 top-1/2 -translate-y-1/2 bg-black/50 text-white px-4 py-2 rounded-full hover:bg-black"
      >
        ‹
      </button>

      {/* RIGHT ARROW */}
      <button
        onClick={nextSlide}
        aria-label="Next Slide"
        className="absolute right-5 top-1/2 -translate-y-1/2 bg-black/50 text-white px-4 py-2 rounded-full hover:bg-black"
      >
        ›
      </button>

      {/* DOTS */}
      <div className="absolute bottom-6 w-full flex justify-center gap-3">
        {slides.map((slide, index) => (
          <button
            key={slide.id}
            onClick={() => setCurrent(index)}
            aria-label={`Go to slide ${index + 1}`}
            className={`w-3 h-3 rounded-full transition ${
              index === current
                ? "bg-white scale-125"
                : "bg-white/50"
            }`}
          />
        ))}
      </div>
    </section>
  );
}